import CustomTextField from "../Atoms/TextFields/CustomTextField";
import CustomDropdown from "../Atoms/DropDowns/CustomDropdown";
import { useAgent } from "../../contexts/AgentsContext";
import "./custom.form.css";
import { CircularProgress } from "@mui/material";

const CustomForm = ({
  cols = [6],
  title = "",
  fields = [],
  clsNames,
  onFieldChange,
}) => {
  const { ongoingAgentData } = useAgent();

  return (
    <section className={clsNames}>
      <div className="row">
        {fields?.map((field, index) => {
          return (
            <>
              <div className={`col-${cols[index] || 6}`}>
                {field?.type === "text" ? (
                  <>
                    <label className={field?.labelCls}>
                      {field?.label}
                      {field?.required && (
                        <span className="marketplace-req-asterik">*</span>
                      )}
                    </label>{" "}
                    <CustomTextField
                      clsNames={`${field?.fieldCls}`}
                      placeholder={field?.placeholder}
                      value={
                        field.value !== undefined
                          ? field.value
                          : ongoingAgentData[field.name] || ""
                      }
                      handleOnChange={(e) => {
                        if (onFieldChange) {
                          onFieldChange(field.name, e.target.value);
                        }
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}
                {field?.type === "dropdown" ? (
                  <>
                    <label className={field?.labelCls}>
                      {field?.label}
                      {field?.required && (
                        <span className="marketplace-req-asterik">*</span>
                      )}
                    </label>
                    <div className="d-flex align-items-center">
                      <CustomDropdown
                        selectValues={field.options || []}
                        value={
                          field.value !== undefined
                            ? field.value
                            : ongoingAgentData[field.name] || ""
                        }
                        handleOnChange={(value) => {
                          if (onFieldChange) {
                            onFieldChange(field.name, value);
                          }
                        }}
                        dropdownLabel={
                          field?.placeholder || "Select an option..."
                        }
                        clsNames={`${field?.fieldCls}`}
                        disabled={field?.disabled}
                      />
                      {field?.loader && (
                        <CircularProgress
                          style={{
                            width: "15px",
                            height: "15px",
                            opacity: 0.8,
                            marginLeft: "5px",
                          }}
                        />
                      )}
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </>
          );
        })}
      </div>
    </section>
  );
};

export default CustomForm;
